import React from "react";

import "./InitialFormStyleSheet.css";

function InitialFormHeader(props) {
  const onClose = () => props.actions.onStartUpClick();

  return (
    <div className="s360-initial-form-header" style={props.config?.customDesign?.initialFormHeader}>
      <div className="s360-initial-form-header-message">
        <div className="s360-initial-form-header-salutation-message" style={props.config?.customDesign?.initialFormHeaderMessage}>
          <h4>{props.config.configDetails?.formMessage}</h4>
          <div className="s360-default-header-icon" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13.624"
              height="53"
              viewBox="0 0 13.624 8.209"
            >
              <path
                id="down-arrow"
                d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                transform="translate(-2364.171 -5054.96)"
                style={props.config?.customDesign?.initialFormHeaderIcon}
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InitialFormHeader;
